import variables from '../variables';

const secondary = {
    main: variables.themeColors.secondary,
};

export default secondary;
